import { useAds } from '../context/AdContext.jsx';

// Ported premium loader overlay from QuizzyLoot, driven by ad-service state.
export default function AdLoaderOverlay() {
  const { loader, status, abort } = useAds();

  if (!loader?.show) return null;

  return (
    <div className="fixed inset-0 z-[100] bg-slate-950/95 backdrop-blur-3xl flex flex-col items-center justify-center transition-all duration-500">
      <div className="relative mb-10">
        <div className="absolute inset-[-40px] rounded-full bg-violet-500/10 blur-[60px] animate-pulse"></div>
        <div className="w-36 h-36 loader-ring rounded-full animate-spin"></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-20 h-20 bg-slate-900 rounded-3xl flex items-center justify-center border border-white/10 shadow-2xl">
            <span className="text-4xl animate-bounce">⚡</span>
          </div>
        </div>
      </div>

      <div className="text-center space-y-4 px-8">
        <h2 className="text-2xl font-extrabold uppercase tracking-tight text-white italic">
          {loader?.text}
        </h2>
        <div className="flex items-center justify-center gap-2">
          <span className="w-2 h-2 bg-violet-500 rounded-full animate-ping"></span>
          <p className="text-[10px] text-violet-400 font-bold uppercase tracking-[0.4em]">
            {status?.text}
          </p>
        </div>
        <button
          onClick={abort}
          className="mt-8 px-10 py-3 bg-white/5 hover:bg-white/10 border border-white/10 rounded-2xl text-[10px] font-bold uppercase tracking-widest text-slate-400 hover:text-white transition-all"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
